'use client'

import React from 'react'

import type { Announcement } from '@/payload-types'

import RichText from '@/components/RichText'
import { CMSLink } from '@/components/Link'
import { Media } from '@/components/Media'
import { DefaultTypedEditorState } from '@payloadcms/richtext-lexical'
import { cn } from '@/utilities/ui'

interface AnnouncementClientProps {
  data: Announcement
}

export const AnnouncementClient: React.FC<AnnouncementClientProps> = ({ data }) => {
  if (!data.enabled) return null
  return (
    <div className="relative top-0 w-full z-20 bg-rock-3 drop-shadow-xs">
      <div
        className={cn(
          'flex-1 h-full w-full container py-2 px-4 mx-auto relative',
          'flex items-center justify-between gap-4',
        )}
      >
        {data.icon && (
          <div>
            <Media resource={data.icon} className="w-6 h-6" placeholder="empty" />
          </div>
        )}
        <div className="flex-1 flex h-full w-full">
          <RichText
            enableProse={false}
            data={data.message as DefaultTypedEditorState}
            className="flex items-center !font-diatype text-[1rem]"
          />
        </div>
        <div className="">
          <CMSLink {...data.link} label="" variant="olive" size="icon" className="md:hidden" />
          <CMSLink {...data.link} variant="olive" className="hidden md:inline-flex" />
        </div>
      </div>
    </div>
  )
}
